/**
 * 패널 전반에서 공유하는 상태색 토큰 — 정상=green / 경고=amber / 위험=red(destructive).
 * 진단 배지(pass/warn/fail), 브릿지 배지(native/mock) 등 모든 상태 표시가 이 3색을 쓴다.
 * 각 패널이 인라인 색을 흩뿌리지 않도록 한 곳에 모은다(#20 시각계층 통일).
 */
export type StatusTone = 'ok' | 'warn' | 'danger';

export const STATUS_TONE: Record<StatusTone, string> = {
  ok: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-600',
  warn: 'border-amber-500/40 bg-amber-500/10 text-amber-600',
  danger: 'border-destructive/50 bg-destructive/10 text-destructive',
};
